module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division",
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "pagev"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap01"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454934721_itr"
    }
  }, [_c('span', {
    staticClass: "brown"
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454934721_p01"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("PART ONE")]), _c('br'), _c('span', {
    staticClass: "big3"
  }, [_c('span', {
    staticClass: "brown"
  }, [_vm._v("DETROIT")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454934721_p02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("PART TWO")]), _c('br'), _c('span', {
    staticClass: "big3"
  }, [_c('span', {
    staticClass: "brown"
  }, [_vm._v("REINVENTION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454934721_p03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("PART THREE")]), _c('br'), _c('span', {
    staticClass: "big3"
  }, [_c('span', {
    staticClass: "brown"
  }, [_vm._v("DIVA")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454934721_p04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("PART FOUR")]), _c('br'), _c('span', {
    staticClass: "big3"
  }, [_c('span', {
    staticClass: "brown"
  }, [_vm._v("HONORS & AWARDS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454934721_p05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("CODA")]), _c('br'), _c('span', {
    staticClass: "big3"
  }, [_c('span', {
    staticClass: "brown"
  }, [_vm._v("PAYING THEIR R-E-S-P-E-C-T")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap11"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454934721_bm1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Discography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454934721_ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454934721_nts",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454934721_pcr",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Picture Credits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454934721_ata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b38cd31","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781454934721_toc.vue
// module id = 72
// module chunks = 0